// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import LookupPayrollsRequestModel from '../../model/lookup-payrolls-request-model';
import GuidLookupListResultModel from '../../model/guid-lookup-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async lookupPayrolls(request: LookupPayrollsRequestModel, config?: RequestConfig) {
    const requestDTO = LookupPayrollsRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-lookup-payrolls'] ?? 'Payroll';
    const response = await service.get<any>(endpointPath, {
      query: {
        zipCode: requestDTO.zipCode,
        zipCodeAddition: requestDTO.zipCodeAddition,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(GuidLookupListResultModel.toModel(dto));
  },
});
